import { useTranslation } from 'react-i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GENERAL_STYLE, FORGOT_PASSWORD_FLOW } from '../constants';
import LoginCard from '../../../components/LoginCard';
import Heading from '../../../../../generic-components/Heading';
import Button from '../../../../../generic-components/Button';
import Lottie from '../../../../../generic-components/Lottie';
import CheckSignLottie from '../../../../../assets/lotties/checkmark_success_animation.json';
import { LoginHelpNavBar } from '../LoginHelpNavBar';
import { VIEWS_MAP } from '../../../../../router/constants';
import { Layout } from '../../../../../components/Layout/Layout';

const ForgotPasswordSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const description = (
    <Heading
      title={t(FORGOT_PASSWORD_FLOW.SUCCESS.DESCRIPTION)}
      className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} mb-[95px] text-center`}
    />
  );
  const heading = (
    <Heading
      title={t(FORGOT_PASSWORD_FLOW.SUCCESS.TITLE)}
      className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[12px] text-center`}
    />
  );

  const lottie = (
    <Lottie
      className='w-[96px] h-[96px] mb-[36px]'
      isAutoplay
      isLoop={false}
      lottieAsset={CheckSignLottie}
    />
  );

  const actionButton = (
    <Button
      id='continueToLoginBtn'
      title={t(FORGOT_PASSWORD_FLOW.SUCCESS.CONTINUE_BUTTON_TITLE)}
      className={GENERAL_STYLE.MAIN_BUTTON.CLASS_NAME}
      onClick={() => {
        navigate(`/${VIEWS_MAP.LOGIN}`);
      }}
    />
  );

  return (
    <Layout shouldHideProfile shouldHideChatBot wrapperClassName='pt-[78px] pl-[72px] ml-[100px] pc-md:ml-[256px]'>
      <LoginHelpNavBar
        onBackClick={() => {}}
        onCloseClick={() => navigate(`/${VIEWS_MAP.LOGIN}`)}
        hideBackIcon
      />
      <LoginCard className={GENERAL_STYLE.LOGIN_CARD.CLASS_NAME} hideLiliIcon>
        <div className='flex flex-col justify-between h-full'>
          <div className='flex flex-col items-center '>
            {lottie}
            {heading}
            {description}
          </div>
          {actionButton}
        </div>

      </LoginCard>
    </Layout>
  );
};

export default ForgotPasswordSuccess;
